import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ChatDataService {

  constructor() { }

  private _newChat = new BehaviorSubject(false);
  public newChat: Observable<any> = this._newChat.asObservable();

  private _chatStatus = new BehaviorSubject({ messages: [], isTyping: false, isMinimized: false });
  public chatStatus: Observable<any> = this._chatStatus.asObservable();

  public ProdORuat = new Subject<number>();

  private dataStore: { newChat: boolean } = { newChat: false };

  public clear() {
    this.dataStore = { newChat: false };
    this._newChat.next(false);
  }

  setChatStatus(status: any): void {
    const currentStatus = this._chatStatus.getValue();
    this._chatStatus.next({ ...currentStatus, ...status });
  }

  getChatStatus(): any {
    return this._chatStatus.getValue();
  }
}
